import * as React from 'react';
import BCInput from '../../../BCInput';
import Styles from '../../assets/style.scss';
import { IPropertyComponentProps, IPropertyItem } from '../../entities';

const defaultStyle: React.CSSProperties = { width: '100%' };
const PasswordProperty = (props: IPropertyComponentProps) => {
	const replaceValue = (item: IPropertyItem, newValue: any) => {
		props.onValueChanged(item, newValue);
	};

	const onChange = (e: any) => {
		props.customChangeEvent
			? props.customChangeEvent(e.data)
			: replaceValue(props.item, e.data);
	};

	return (
		<BCInput
			value={props.value || props.item.placeholder}
			onChange={onChange}
			disabled={props.item.disabled}
			readOnly={props.item.readOnly || props.readonly}
			style={props.style || defaultStyle}
			type="text"
			className={Styles.inputSecurity}
			size="small"
		/>
	);
};
export default PasswordProperty;
